module.exports = __webpack_public_path__ + "static/media/supplement-DNA-Analytics-1.f6b587c8.svg";